// extracted by mini-css-extract-plugin
export default {"tabs":"HistoryTab_tabs__3lgeh","tab_box":"HistoryTab_tab_box__SKIps"};